import { atom } from 'jotai';

export const opalOverlayOpenAtom = atom(false);
